import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import '../../styles/MainCategorySelection.css';

interface CategoryCardProps {
    id: string;
    name: string;
    description?: string;
    image: string;
    index: number;
    onClick: (id: string) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ id, name, description, image, index, onClick }) => {
    return (
        <motion.div
            className="category-selection-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            onClick={() => onClick(id)}
            style={{ textAlign: "left" }}
        >
            <div className="category-card-image-wrapper">
                <img
                    src={image || 'https://via.placeholder.com/400x300?text=Category'}
                    alt={name}
                    style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: '100%',
                        borderRadius: '8px'
                    }}
                />
                <div className="category-card-overlay">
                    <div className="explore-btn">
                        Explore Collection <FaArrowRight />
                    </div>
                </div>
            </div>
            <div className="category-card-content">
                <div className="category-card-info-top">
                    <h3 className="category-card-name">{name}</h3>
                    <p className="category-card-desc">
                        {description || `Premium collection of ${name.toLowerCase()} for your everyday needs.`}
                    </p>
                </div>
                <div className="category-card-footer">
                    <div className="view-products-link">
                        <span>VIEW DETAILS</span>
                        <div className="arrow-circle">
                            <FaArrowRight size={12} />
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default CategoryCard;
